import Vue from 'vue';

export const gotedoEditor = {
  namespaced: true,
  state: () => {
    return {
      cachedOutputData: {},
    };
  },
  getters: {
    getOutputData: (state) => (id) => {
      return state.cachedOutputData[id] ?? null;
    },
  },
  mutations: {
    saveOutputData: (state, { id, data }) => {
      Vue.set(state.cachedOutputData, id, data);
    },

    removeOutputData: (state, id) => {
      Vue.set(state.cachedOutputData, id, null);
    },
  },
};
